import { BLOGS_ENDPOINTS } from "../constants/apiEndpoints";
import { deleteWrapper, getWrapper, postWrapper, putWrapper } from "../utils/Wrapper";

export const getBlogs = (pageable = {}) => {
  const { page, size, startDate, endDate, contentType, searchQuery, sortBy, order } = pageable;
  const params = new URLSearchParams();
  if (Number.isFinite(page)) params.append("page", page);
  if (Number.isFinite(size)) params.append("size", size);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (contentType) params.append("contentType", contentType);
  if (searchQuery) params.append("searchQuery", searchQuery);
  if (sortBy) params.append("sortBy", sortBy);
  if (order) params.append("order", order);
  const url = `${BLOGS_ENDPOINTS.GET_BLOGS}${params.toString() ? `?${params.toString()}` : ""}`;
  return getWrapper(url);
};

export const getBlogById = (blogId) => {
  const url = `${BLOGS_ENDPOINTS.GET_BLOG_BY_ID}/${blogId}`;
  return getWrapper(url);
};

// export const getBlogs = async (pageable) => {

//     try {
//         const token = localStorage.getItem('token');
//         if (!token) {
//             throw new Error('Authentication token not found');
//         }
//         const url = `${API_BASE_URL}${BLOGS_ENDPOINTS.GET_BLOGS}?${pageable?.page?`&page=${pageable?.page}`:""}${pageable?.size?`&size=${pageable?.size}`:""}${pageable?.startDate?`&startDate=${pageable?.startDate}`:""}${pageable?.endDate?`&endDate=${pageable?.endDate}`:""}`;
//         const response = await fetch(url, {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${token}`
//             }
//         });

//         if (!response.ok) {
//             throw new Error(`Failed to fetch Blogs: ${response.status}`);
//         }

//         const data = await response.json();
//         return data;
//     } catch (error) {
//         console.error('Error fetching Blogs:', error);
//         throw error;
//     }
// };

// export const getBlogById = async (blogId) => {

//     try {
//         const token = localStorage.getItem('token');
//         if (!token) {
//             throw new Error('Authentication token not found');
//         }
//         const url = `${API_BASE_URL}${BLOGS_ENDPOINTS.GET_BLOG_BY_ID}/${blogId}`;
//         const response = await fetch(url, {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${token}`
//             }
//         });
//         if (!response.ok) {
//             console.error('Error status:', response.status, response.statusText);
//             throw new Error(`Failed to fetch Blog details: ${response.status}`);
//         }
//         const data = await response.json();
//         return data;
//     } catch (error) {
//         console.error('Error fetching Blog details:', error);
//         throw error;
//     }
// };

export const deleteBlogById = (blogId) => {
  const url = `${BLOGS_ENDPOINTS.DELETE_BLOG}?id=${blogId}`;
  return deleteWrapper(url);
};

// export const deleteBlogById = async (blogId) => {

//     try {
//         const token = localStorage.getItem('token');
//         if (!token) {
//             throw new Error('Authentication token not found');
//         }
//         const url = `${API_BASE_URL}${BLOGS_ENDPOINTS.DELETE_BLOG}?id=${blogId}`;
//         const response = await fetch(url, {
//             method: 'DELETE',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${token}`
//             }
//         });
//         if (!response.ok) {
//             console.error('Error status:', response.status, response.statusText);
//             throw new Error(`Failed to delete Blog details: ${response.status}`);
//         }
//         const data = await response.json();
//         return data;
//     } catch (error) {
//         console.error('Error delete Blog', error);
//         throw error;
//     }
// };

export const publishBlog = (data) => {
  let url = `${BLOGS_ENDPOINTS.CREATE_BLOG}`;
  return postWrapper(url, data);
};

export const updateBlog = (data) => {
  let url = `${BLOGS_ENDPOINTS.UPDATE_BLOG}`;
  return putWrapper(url, data);
};

export const deleteBlogImageById = (imageId) => {
  const url = `${BLOGS_ENDPOINTS.DELETE_IMAGE}/${encodeURIComponent(imageId)}`;
  return deleteWrapper(url);
};